export interface IUserDetailsState {
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  id: number;
  fbId: string;
  parentId: number;
  parentFbId: string;
  username: string;
  email: string;
  role: string;
  roleName: string;
  countryId: number;
  status: boolean;
  barcodeScanEnabled: boolean;
  phoneCode: string;
  phoneNumber: string;
  quota: {
    coupon: {
      renewDate: number;
      isCancellation: boolean;
      dailyCancellation: number;
    };
  };
  customerNo: string;
  dateOfBirth: string;
  street: string;
  postCode: string;
  location: string;
  countryCurrency: string;
  countryName: string;
  firstname: string;
  lastname: string;
  country: {
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    id: number;
    currency: string;
    isDefault: boolean;
    maxWinnings: number;
    minStakes: number;
    name: string;
    stakes: number[];
    stakesMultiplier: number;
  };
  balance: number;
}

export const initialUserDetailsState: IUserDetailsState = {
  createdAt: '',
  updatedAt: '',
  deletedAt: null,
  id: 0,
  fbId: '',
  parentId: 0,
  parentFbId: '',
  username: '',
  email: '',
  role: '',
  roleName: '',
  countryId: 0,
  status: false,
  barcodeScanEnabled: false,
  phoneCode: '',
  phoneNumber: '',
  quota: {
    coupon: {
      renewDate: 0,
      isCancellation: false,
      dailyCancellation: 0,
    },
  },
  customerNo: '',
  dateOfBirth: '',
  street: '',
  postCode: '',
  location: '',
  countryCurrency: '',
  countryName: '',
  firstname: '',
  lastname: '',
  country: {
    deletedAt: null,
    id: 0,
    currency: '',
    isDefault: false,
    createdAt: '',
    updatedAt: '',
    maxWinnings: 0,
    minStakes: 0,
    name: '',
    stakes: [],
    stakesMultiplier: 0,
  },
  balance: 0,
};
